// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import axios from 'axios'
import 'babel-polyfill'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vue from 'vue'
import App from './App'
import './assets/css/function.styl'
import './assets/css/mine.styl'
import './assets/css/variable.styl'
import router from './router'
import store from './store'

Vue.config.productionTip = false
Vue.use(ElementUI)
// axios.defaults.baseURL = 'http://192.168.10.123:8088'
// axios.defaults.baseURL = 'http://10.0.0.69:8080/'
axios.defaults.baseURL = 'http://www.yaozhicai.cn:8088'
Vue.prototype.$http = axios

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js